<template>
  <div class="page-body">
    <b-card class="content-card">
      <div fluid>
        <div class="appbar-container">
          <h3 class="appbar-container__title">
            جایز های دریافت شده - پرداخت شده ها
          </h3>
        </div>
        <div class="filters-container">
          <h4 class="title">فیلتر بر اساس :</h4>
          <div class="filters">
            <b-row class="w-100">
              <b-col sm="3" class="text-right">
                <base-input
                  label="آیدی کاربر(uuid)"
                  v-model="filters.user_id"
                />
              </b-col>
              <b-col sm="3" class="text-right">
                <base-input
                  label="شرط جایزه"
                  v-model="filters.reward_condition_type"
                />
              </b-col>
              <b-col sm="3" class="text-right">
                <base-input label="آیدی جایزه" v-model="filters.reward_id" />
              </b-col>
              <b-col sm="3" class="text-right">
                <base-input
                  type="number"
                  label="کمترین قیمت"
                  v-model="filters.amount_low"
                />
              </b-col>
              <b-col sm="3" class="text-right">
                <base-input
                  type="number"
                  label="بیشترین قیمت"
                  v-model="filters.amount_high"
                />
              </b-col>
              <b-col sm="3" class="text-right">
                <base-input
                  label="رمزارز ها"
                  placeholder="با ، از کم جدا کنید"
                  v-model="filters.tokens"
                />
              </b-col>
              <b-col sm="3" class="text-right">
                <label for=""> تاریخ شروع </label>
                <date-picker v-model="filters.date_low" />
              </b-col>
              <b-col sm="3" class="text-right">
                <label for=""> تاریخ پایان </label>
                <date-picker v-model="filters.date_high" />
              </b-col>
            </b-row>
          </div>
          <div class="actions text-right">
            <b-button
              @click="fetchData()"
              size="md"
              variant="primary"
              class="mr-1"
            >
              جستجو
            </b-button>
          </div>
        </div>
        <b-skeleton-table
          v-if="loading"
          :rows="5"
          :columns="5"
          :table-props="{ bordered: true, striped: true }"
        >
        </b-skeleton-table>
        <b-table
          class="reward-table"
          v-else
          :items="items"
          :fields="fields"
          empty-text="موردی یافت نشد"
          stacked="md"
          show-empty
          small
        >
          <template #cell(reward_name)="row">
            <div class="text-center">
              {{ row.item.reward_name }}
            </div>
          </template>

          <template #cell(user)="row">
            <div class="text-center">
              <b-button :to="`/user-profile/${row.item.user_id}`" size="sm" variant="primary">
                نمایش اطاعات کاربر
              </b-button>
            </div>
          </template>

          <template #cell(name)="row">
            <div class="text-center">
              {{ row.item.date }}
            </div>
          </template>

          <template #cell(status)="row">
            <div class="text-center">
              {{ row.item.date }}
            </div>
          </template>

          <template #cell(campaign)="row">
            <div class="text-center">
              <badge type="warning">
                {{ row.item.token }}
              </badge>
            </div>
          </template>
        </b-table>
      </div>
    </b-card>
    <b-row no-gutters>
      <b-col sm="12" class="my-1 d-flex justify-content-center">
        <BasePagination
          :showNext="showNext"
          :showPrev="filters.page_number !== 0"
          @onClick="handlePaginationClick"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { fetchAchievedRewards } from "@/httpservices/Reward";
import BasePagination from "@/components/BasePagination.vue";
import moment from "jalali-moment";
import _ from "lodash";
export default {
  name: "Paid",

  data() {
    return {
      loading: true,
      filters: {
        page_number: 0,
        page_size: 10,
        user_id: null,
        reward_condition_type: null,
        reward_id: null,
        amount_low: null,
        amount_high: null,
        tokens: null,
        date_low: null,
        date_high: null,
        paid: true,
        confirmed: true,
      },
      items: [],
      fields: [
        {
          key: "reward_name",
          label: "نام جایزه",
          sortable: false,
          class: "text-center",
        },
        {
          key: "user",
          label: "کاربر",
          sortable: false,
          class: "text-center",
        },
        {
          key: "date",
          label: "تاریخ",
          sortable: false,
          class: "text-center",
        },
        {
          key: "amount",
          label: "مبلغ",
          sortable: false,
          class: "text-center",
        },
        {
          key: "token",
          label: "رمزارز",
          sortable: false,
          class: "text-center",
        },
      ],
    };
  },

  mounted() {
    this.$nextTick(() => {
      this.fetchData();
    });
  },

  components: {
    BasePagination,
  },

  computed: {
    showNext() {
      if (this.filters.page_number === 0) {
        if (this.items.length < this.filters.perPage) {
          return false;
        } else {
          return true;
        }
      } else {
        if (
          this.items.length < this.filters.perPage ||
          this.items.length === 0
        ) {
          return false;
        } else {
          return true;
        }
      }
    },
  },

  methods: {
    handlePaginationClick(value) {
      if (value === -1) {
        if (this.filters.page_number > 0) {
          this.filters.page_number--;
          this.fetchData();
        }
      } else if (value === 1) {
        this.filters.page_number++;
        this.fetchData();
      }
    },

    async fetchData() {
      this.loading = true;
      fetchAchievedRewards(
        _.mapValues(this.filters, (v) => (v === "" ? null : v))
      )
        .then((res) => {
          this.loading = false;
          this.items = res.data.data.map((item) => {
            return {
              ...item,
              date:
                item.date &&
                moment(item.date).locale("fa").format("jYYYY-jMM-jDD"),
            };
          });
        })
        .catch((e) => {
          console.log({ e });
        });
    },
  },
};
</script>

<style lang="scss">
.appbar-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;

  &__title {
    font-size: 24px;
  }
}

.filters-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 15px;
  padding: 15px;
  background-color: #eee;
  border-radius: 5px;

  .title {
    display: flex;
    min-width: 150px;
  }

  .filters {
    width: 100%;
    flex-grow: 1;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  .actions {
    display: flex;
  }
}
</style>
